import authHeader from "../helpers/functions/auth-header";
import axios from "axios";
import { settings } from "../helpers/settings";

const API_URL = settings.apiURL;

// Register
export const register = (user) => {
  return axios.post(`${API_URL}/register.php`, user); //test etmedim.
};

// Login
export const login = (credential) => {
  const jsonCredential = {};
  for (const [key, value] of credential.entries()) {
    jsonCredential[key] = value;
  }
  return axios.post(`${API_URL}/login.php`, jsonCredential);
};

// get getUser
export const getUser = () => {
  return axios.get(`${API_URL}/get_user.php`, { headers: authHeader() });
};

// Forgot Password ➔ Şifremi Unuttum Linki Gönder
export const forgotPassword = (emailObj) => {
  return axios.post(`${API_URL}/forgot_password.php`, emailObj);
};

// Reset Password ➔ Yeni Şifreyi Kaydet
export const resetPassword = (resetObj) => {
  return axios.post(`${API_URL}/reset_password.php`, resetObj);
};

// Tasarım Yükleme
export const uploadDesign = (formData) => {
  return axios.post(`${API_URL}/upload_design.php`, formData, {
    headers: {
      ...authHeader(), // JWT token
      "Content-Type": "multipart/form-data",
    },
  });
};


